import React from 'react'

const ProjectScientist = () => {
  return (
    <div className="album py-2">
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href=""
        >
          <b> Md Adil </b>
        </a>
        (2022-2023)
      </li>

      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href="https://www.linkedin.com/in/parth-kanani-177a4019b/"
        >
          <b> Parth Kanani </b>
        </a>
        (2023-2024)
      </li>

  </div>
  )
}

export default ProjectScientist